module.exports = __webpack_public_path__ + "static/media/gulp3.2b2614e3.mp3";